import { render, staticRenderFns } from "./page_manage.vue?vue&type=template&id=4d9b6e82&scoped=true"
import script from "./page_manage.vue?vue&type=script&lang=js"
export * from "./page_manage.vue?vue&type=script&lang=js"
import style0 from "./page_manage.vue?vue&type=style&index=0&id=4d9b6e82&prod&lang=less"
import style1 from "./page_manage.vue?vue&type=style&index=1&id=4d9b6e82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b6e82",
  null
  
)

export default component.exports